import {
    Crosshair,
    Ruler,
    Hammer,
    Flame,
    Cog,
    Workflow,
} from "lucide-react";

const BENEFITS = [
    {
        icon: Crosshair,
        title: "Corte a laser preciso",
        desc: "Acabamento limpo e alta tolerância dimensional para peças com precisão exigente.",
    },
    {
        icon: Ruler,
        title: "Dobra CNC padronizada",
        desc: "Repetibilidade e consistência em séries longas, reduzindo variações de processo.",
    },
    {
        icon: Hammer,
        title: "Caldeiraria resistente",
        desc: "Estruturas robustas dimensionadas para operações de alta exigência no agro.",
    },
    {
        icon: Flame,
        title: "Soldagem industrial robusta",
        desc: "Processos qualificados para maior durabilidade estrutural e confiabilidade.",
    },
    {
        icon: Cog,
        title: "Usinagem sob medida",
        desc: "Componentes técnicos fabricados conforme projeto, desenho ou amostra.",
    },
    {
        icon: Workflow,
        title: "Produção integrada",
        desc: "Corte, dobra, solda e usinagem em fluxo único — prazo e qualidade sob controle.",
    },
];

export const Benefits = () => {
    return (
        <section
            id="beneficios"
            data-testid="benefits-section"
            className="bg-buzas-gray section-pad"
        >
            <div className="container-buzas">
                <div className="max-w-3xl mb-14">
                    <span className="eyebrow text-buzas-red">
                        Benefícios técnicos
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-buzas-navy leading-tight">
                        Benefícios técnicos para uma operação mais eficiente.
                    </h2>
                    <p className="mt-4 text-base md:text-lg text-buzas-navy/70 leading-relaxed">
                        Capacidade fabril integrada, projetada para entregar
                        peças com precisão, padrão e desempenho em campo.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {BENEFITS.map(({ icon: Icon, title, desc }, i) => (
                        <article
                            key={title}
                            data-testid={`benefit-card-${i}`}
                            className="group relative bg-white rounded-sm border border-buzas-gray-200 p-7 md:p-8 shadow-[0_1px_0_rgba(10,37,64,0.04)] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
                        >
                            <div className="flex items-center justify-between">
                                <div className="inline-flex h-11 w-11 items-center justify-center rounded-sm bg-buzas-navy-50 text-buzas-navy group-hover:bg-buzas-navy group-hover:text-white transition-colors">
                                    <Icon
                                        className="h-5 w-5"
                                        strokeWidth={1.75}
                                    />
                                </div>
                                <span className="text-[10px] font-bold tracking-[0.22em] uppercase text-buzas-gray-500">
                                    0{i + 1}
                                </span>
                            </div>
                            <h3 className="mt-6 text-lg md:text-xl font-bold text-buzas-navy">
                                {title}
                            </h3>
                            <p className="mt-2 text-sm md:text-[15px] text-buzas-navy/70 leading-relaxed">
                                {desc}
                            </p>
                            <span
                                aria-hidden
                                className="absolute left-0 top-0 h-0.5 w-0 bg-buzas-red group-hover:w-full transition-all duration-500"
                            />
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
